export default "__VITE_ASSET__Ctk_wQMC__"